import { render, staticRenderFns } from "./ChampionshipMatchCard.vue?vue&type=template&id=458506a7&scoped=true"
import script from "./ChampionshipMatchCard.vue?vue&type=script&lang=js"
export * from "./ChampionshipMatchCard.vue?vue&type=script&lang=js"
import style0 from "./ChampionshipMatchCard.vue?vue&type=style&index=0&id=458506a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458506a7",
  null
  
)

export default component.exports